'use client'

import Link from 'next/link'
import { Button } from '@/components/ui/button'
import HomeSlider from '@/components/home-slider'
import {
  BarChart3,
  Users,
  Trophy,
  Calendar,
  LogIn,
  UserPlus,
  Eye,
} from 'lucide-react'

export default function HomePage() {
  return (
    <main className="flex min-h-screen flex-col">
      {/* Navigation */}
      <nav className="flex items-center justify-between border-b border-border px-6 py-4">
        <div className="text-2xl font-bold text-primary">Cosmicon Events</div>
        <div className="flex gap-2 md:gap-4 flex-wrap">
          <Button variant="ghost" size="sm" asChild>
            <Link href="/admin/login">
              <LogIn className="mr-2 h-4 w-4" />
              Admin
            </Link>
          </Button>
          <Button variant="ghost" size="sm" asChild>
            <Link href="/judge/login">
              <LogIn className="mr-2 h-4 w-4" />
              Judge
            </Link>
          </Button>
          <Button size="sm" asChild>
            <Link href="/register">
              <UserPlus className="mr-2 h-4 w-4" />
              Register
            </Link>
          </Button>
        </div>
      </nav>

      {/* Hero Slider */}
      <section className="px-6 py-6">
        <HomeSlider />
      </section>

      {/* Secondary Call-to-Action */}
      <section className="px-6 py-8 bg-muted/30">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl font-bold mb-3">Join Us!</h2>
          <p className="text-muted-foreground mb-6">
            Whether you&apos;re a contestant or a spectator, there&apos;s a place for you at Cosmicon Events
          </p>
          <div className="flex flex-col md:flex-row gap-4 justify-center">
            <Button size="lg" asChild>
              <Link href="/register">
                <UserPlus className="mr-2 h-4 w-4" />
                Register as Contestant
              </Link>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <Link href="/events">
                <Eye className="mr-2 h-4 w-4" />
                Register as Attendee
              </Link>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <Link href="/events">View Upcoming Events</Link>
            </Button>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="grid gap-6 px-6 py-16 md:grid-cols-2 lg:grid-cols-4">
        {/* <div className="flex flex-col gap-3 rounded-lg border border-border bg-card p-6">
          <Calendar className="h-8 w-8 text-primary" />
          <h3 className="font-semibold">Event Management</h3>
          <p className="text-sm text-muted-foreground">
            Create and manage events with detailed program flows and schedules
          </p>
        </div>

        <div className="flex flex-col gap-3 rounded-lg border border-border bg-card p-6">
          <Users className="h-8 w-8 text-primary" />
          <h3 className="font-semibold">Contestant Registration</h3>
          <p className="text-sm text-muted-foreground">
            Simple signup forms with file uploads for character portfolios
          </p>
        </div>

        <div className="flex flex-col gap-3 rounded-lg border border-border bg-card p-6">
          <Trophy className="h-8 w-8 text-primary" />
          <h3 className="font-semibold">Dynamic Judging</h3>
          <p className="text-sm text-muted-foreground">
            Flexible criteria setup with real-time score tracking
          </p>
        </div>

        <div className="flex flex-col gap-3 rounded-lg border border-border bg-card p-6">
          <BarChart3 className="h-8 w-8 text-primary" />
          <h3 className="font-semibold">Results & Analytics</h3>
          <p className="text-sm text-muted-foreground">
            Comprehensive scoring summaries and deliberation management
          </p>
        </div> */}
      </section>

      {/* Footer */}
      <footer className="border-t border-border bg-muted/30 px-6 py-8 text-center text-sm text-muted-foreground">
        <p>&copy; 2026 Cosmicon Events. Managed for cosplay events by the community. Maintained by Dark Glass Aperture</p>
      </footer>
    </main>
  )
}
